module.exports = __webpack_public_path__ + "b9095ee7f8ef550bfdbed518db5c12c2.svg";